export default "__VITE_ASSET__4c30d624__"